import { React, useContext, useEffect} from 'react';
import { AuthContext } from '../../context';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import banner from '../../imgs/banner.jpg';
import { device } from '../../constants/devices';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import Aos from 'aos';
import "aos/dist/aos.css";
import '../../App.css';
import img1 from '../../imgs/menu_1.png';
import img2 from '../../imgs/menu_2.png';
import img3 from '../../imgs/menu_3.png';
import img4 from '../../imgs/menu_4.png';
import img5 from '../../imgs/Back1.jpg';


SwiperCore.use([ Navigation, Pagination]);

const Root = styled.div`
    width: 100%;
    background: #fefff8;
`;

const SlideUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(250px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Banner = styled.section`
    width: 100%;
    height: 800px;
    background: url(${banner}) no-repeat center/cover;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    h1 {
        position: absolute;
        z-index: 1;
        font-size: 100px;
        color: white;
        margin-left: 16px;
        font-family: Times New Roman;
        animation: ${SlideUp} 1.2s ease;
    };

    &::after {
        content: '';
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    };

    @media ${device.mobileXS} {
        h1 {
            font-size: 80px;
        }
    };

    @media ${device.mobileL} {
        h1 {
            font-size: 90px;
        }
    };
    @media ${device.tablet} {
        h1 {
            font-size: 100px;
            text-align: center;
        }
    };
`;

const MainBody = styled.main`
    display: flex;
    flex-direction: column;
`;



const Title = styled.h2`
    margin-top: 80px;
    margin-bottom: 80px;
    border-left: 12px solid #BF0436;
    border-radius: 8px;
    padding-left: 16px;
    font-size: 24px;
    font-family: Times New Roman;
`;

const Description = styled.p`
    @media ${device.mobileXS} {
        width: %;
        padding: 5px 5px;
        line-height: 2;
        letter-spacing: 5px;
        font-family:'AmstelvarAlpha';
        font-style: oblique;
        font-weight: bold;
        font-size: 130%;
        text-align: center;
    };
`;

const Action = styled(Link)`
    @media ${device.mobileXS} {
        width: 85%;
        height: 100px;
        padding: 26px;
        margin-top: 500px;
        background:#BF0436 ;
        border-radius: 16px;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #fefff8;
        line-height: 1;
        transition: transform 0.5s;
        z-index: 1;
        animation: ${SlideUp} 3.2s ease;
    };

    @media ${device.mobileS} {
        padding: 26px;
    };

    @media ${device.mobileM} {
        line-height: 1.5;
    };

    @media ${device.tablet} {
        width: 60%;
        line-height: 2;
    };
    @media ${device.laptopL} {
        width: 30%;
        margin-top: 500px;
    };

    &:hover {
        color: #fefff8;
        text-decoration: none;
        transform: scale(1.1);
    };
`;
const Intro = styled.section`
    @media ${device.mobileXS} {
        display: flex;
        flex-direction: column;
        align-items: center;
    };

`;
const RecommendMenu = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ImageContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;


    @media ${device.laptopL} {
        img {
            width: 25%;
            height: 25%;
        };
    };
`;

const ImageContainer2 = styled.div`

    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    max-width: 100%;
    height: auto;




    @media ${device.laptopL} {
        img {
            width: 90%;
            height: 90%;
        };
    };
`;

const DishImage = styled.img``;


const Location = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export default function HomePage() {
    const { user } = useContext(AuthContext);

    useEffect(() => {
        Aos.init({ duration: 3000 })
    }, [])

    return (
        <Root>
            <Banner>
                <h1>A Gastronomic Experience To Discover​​</h1>
                <Action to={ user ? "/reserve" : "/login"}>Reserve my table today</Action>
            </Banner>
            <MainBody>
                <Intro>
                    <Title data-aos="fade-up">Who are we?</Title>
                    <Description data-aos="fade-up">
In the heart of Tunis, our "The 715 Lounge Coffee" offers refined cuisine, made from local and seasonal products💫​
                    </Description>
                    <ImageContainer2 data-aos="fade-up">
                    <img src={img5} alt="" />
                    </ImageContainer2>
                 </Intro>
                <RecommendMenu>
                    <Title data-aos="fade-up">The 715 Lounge Coffee luxury is a state of mind ✨</Title>
                    <ImageContainer data-aos="fade-up">
                        <DishImage src={img1} alt=""/>
                        <DishImage src={img2} alt=""/>
                        <DishImage src={img3} alt=""/>
                        <DishImage src={img4} alt=""/>
                    </ImageContainer>
                </RecommendMenu>
                <Location>
                    <Title data-aos="fade-up">Where are we ?</Title>
                    <iframe width="1300" height="442" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=1300&amp;height=442&amp;hl=en&amp;q=Horizon%20Informatique%2064%20rue%20Mokhtar%20Attia%201000%20tunis%20Tunis+(The%20715%20Lounge%20Coffee)&amp;t=k&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> <a href="https://mapswebsite.net/fr">MapsWebsite.net</a> <script type='text/javascript' src='https://embedmaps.com/google-maps-authorization/script.js?id=a84243db9d444dfe6101f08e8400a4b09d16c3a4'></script>
                </Location>
            </MainBody>
        </Root>
    )
}
